import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  companyStates: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
  },
  companyData: null,
  permissionLevels: {
    isLoading: false,
    roles: null,
  },
  bulkDeleteState: {
    data: null,
    statusCode: null,
    statusText: null,
  },
  bulkDeleteError: {
    isLoading: false,
    error: false,
  },
  handleExistingAccountStripeState: {
    isLoading: false,
    error: null,
  },
};

export const companySlice = createSlice({
  name: "company",
  initialState: INITIAL_STATE,
  reducers: {
    fetchCompaniesData: (state, { payload }) => {
      state.companyStates.isLoading = true;
      payload;
    },
    fetchCompaniesDataSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      companyStates: {
        ...state.companyStates,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
      companyData: action.payload.data,
    }),
    fetchCompaniesDataFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      companyStates: {
        ...state.companyStates,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),

    deleteCompanyRecord: (state, action: PayloadAction<any>) => {
      state.companyStates.isLoading = true;
      action;
    },

    deleteCompanyRecordSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      companyStates: {
        ...state.companyStates,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),

    deleteCompanyRecordFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      companyStates: {
        ...state.companyStates,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),

    fetchPermissionLevels: (state) => {
      state.permissionLevels.isLoading = true;
    },

    fetchPermissionLevelsSuccess: (state, action) => {
      state.permissionLevels.isLoading = false;
      state.permissionLevels.roles = action.payload;
    },
    fetchPermissionLevelsFailure: (state) => {
      state.permissionLevels.isLoading = false;
    },
    fetchBulkDeleteAccounts: (state) => {
      state.bulkDeleteError.isLoading = true;
    },
    fetchBulkDeleteAccountsSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      bulkDeleteState: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload.data,
      },
      bulkDeleteError: {
        error: false,
        isLoading: false,
      },
    }),
    fetchBulkDeleteAccountsFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      bulkDeleteState: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: null,
      },
      bulkDeleteError: {
        error: true,
        isLoading: false,
      },
    }),
    handleExistingAccountStripe: (state) => {
      state.handleExistingAccountStripeState.isLoading = true;
    },
    handleExistingAccountStripeSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      planState: {
        ...state.handleExistingAccountStripeState,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
      planData: action.payload?.data,
    }),
    handleExistingAccountStripeFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      planState: {
        ...state.handleExistingAccountStripeState,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
    clearCompanies: (state) => ({
      ...state,
      companyStates: {
        ...state.companyStates,
        isLoading: false,
        error: null,
      },

      apiStatus: {
        ...state.apiStatus,
        statusCode: null,
        statusText: null,
      },
      companyData: null,
    }),
  },
});

export const {
  fetchCompaniesData,
  fetchCompaniesDataSuccess,
  fetchCompaniesDataFailure,
  deleteCompanyRecord,
  deleteCompanyRecordSuccess,
  deleteCompanyRecordFailure,
  fetchPermissionLevels,
  fetchPermissionLevelsSuccess,
  fetchPermissionLevelsFailure,
  fetchBulkDeleteAccounts,
  fetchBulkDeleteAccountsFailure,
  fetchBulkDeleteAccountsSuccess,
  handleExistingAccountStripe,
  handleExistingAccountStripeSuccess,
  handleExistingAccountStripeFailure,
  clearCompanies,
} = companySlice.actions;
export const companyReducer = companySlice.reducer;
